const ENDPOINT = new Map();

ENDPOINT.set('enroll', '/plugin/course/enroll');
ENDPOINT.set('redirect', '/plugin/course/redirect');

export default ENDPOINT
